import { Check, FileSpreadsheet, Lock } from "lucide-react";
import { exportFile } from "../lib/exportFile";
import { useAuth } from "../lib/auth";
import { trialEnded } from "../lib/access";
import { useI18n } from "../lib/i18n";
import { Link } from "../lib/router";
import { TopBar, useToast } from "./ui";

export type PaidFeature = "ledger" | "receipt" | "meals" | "board" | "fridge" | "goods";

/** Shown instead of a paid page when the person has no trial or subscription. */
export function Paywall({ feature }: { feature: PaidFeature }) {
  const { t, lang } = useI18n();
  const { me, ai } = useAuth();
  const toast = useToast();
  const name = t(`paywall.feature.${feature}`);
  const ended = me ? trialEnded(me.access) : false;
  return (
    <>
      <TopBar back title={name} />
      <main className="page">
        <section className="card stack" style={{ alignItems: "flex-start", gap: 14, padding: 22 }}>
          <span className="tile-icon" style={{ background: "var(--basil-soft)", color: "var(--basil)", width: 52, height: 52, borderRadius: 16, display: "grid", placeItems: "center" }}>
            <Lock size={26} />
          </span>
          <h1 style={{ fontSize: "var(--step-2)" }}>{t("paywall.title", { feature: name })}</h1>
          <p>{t(`paywall.what.${feature}`)}</p>
          <p className="muted">{ended ? t("paywall.trialEnded", { days: 7 }) : t("paywall.body")}</p>
          <ul className="stack" style={{ listStyle: "none", margin: 0, padding: 0, gap: 8 }}>
            {["plans.plus.f2", "plans.plus.f3", "plans.plus.f4", "plans.plus.f5"].map((k) => (
              <li key={k} className="row" style={{ alignItems: "flex-start" }}>
                <Check size={18} style={{ color: "var(--good)", flex: "none", marginTop: 3 }} />
                <span>{t(k, { n: ai?.plans.plus ?? 100 })}</span>
              </li>
            ))}
          </ul>
          <p className="num" style={{ fontWeight: 700 }}>
            {t("plans.price.year")} {t("plans.price.year.per")} <span className="pill good">{t("plans.recommended")}</span>
            <br />
            <span className="muted" style={{ fontWeight: 400 }}>
              {t("plans.price.month")} {t("plans.price.month.per")}
            </span>
          </p>
          <Link to="/me/plans" className="btn block">
            {t("paywall.cta")}
          </Link>
          {/* Their data is always theirs: the full Excel export works without Plus, straight from here. */}
          <button type="button" className="btn secondary block" onClick={() => exportFile(`/api/account/export?lang=${lang}`, "NutriCart-data.xlsx")}>
            <FileSpreadsheet size={18} /> {t("account.export")}
          </button>
          <p className="small muted">{t("paywall.export")}</p>
        </section>
      </main>
    </>
  );
}
